// @ts-nocheck
const isProduction = () => {
  // CRA
  try {
    if (!process.env.IS_VITE) {
      if (!process.env.REACT_APP_NAME) {
        // old
        return process.env.NODE_ENV === 'production'
      }
      return process.env.REACT_APP_TYPE === 'production'
    }
  } catch (_) {} // eslint-disable-line

  // Vite
  try {
    return import.meta.env.MODE === 'production'
  } catch (_) {} // eslint-disable-line

  return false
}

export default isProduction
